<form [id]="id" [formGroup]="form" (ngSubmit)="submit()">
  <ion-list>
    <ui-form-field
      [control]="form.controls.budgetItem"
      icon="chevron-forward"
      iconSlot="end"
      iconClasses="icon-end fs-16 pt-32"
      class="fs-16"
      lines="full"
      label="pages.fund-cash.purchase.form.budgetItem"
    >
      <ui-budget-item-select
        [formControl]="form.controls.budgetItem"
        [project]="project"
        [projectTasks]="budgetProjectTasks"
        [allowedSubtasks]="allowedSubtasks"
      ></ui-budget-item-select>
    </ui-form-field>

    <ui-form-field [control]="form.controls.notes" label="pages.fund-cash.purchase.form.notes" class="fs-16" data-cy="Notes">
      <ion-textarea [formControl]="form.controls.notes" [autoGrow]="true" [rows]="1"></ion-textarea>
    </ui-form-field>
  </ion-list>

  <ng-container *ngIf="showRecurring && (identity$ | async)?.enableRecurringPayments">
    <ion-item mode="ios" class="mt-16" lines="none">
      <ion-label>{{ 'pages.fund-cash.purchase.form.isRecurringRequested.label' | translate }}</ion-label>
      <ion-toggle [formControl]="form.controls.isRecurringRequested"></ion-toggle>
    </ion-item>
  </ng-container>
</form>
